import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useDeploymentStore } from '@/store/deployment.store';

export default function SsoLogin() {
  const { mode, samlDomain } = useDeploymentStore((state) => state.profile.login);
  const shouldAutoRedirect = mode === 'saml' && Boolean(samlDomain);
  const navigate = useNavigate();
  const [domain, setDomain] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!shouldAutoRedirect || !samlDomain) {
      return;
    }

    // SAML IdP 登录不属于 Platform 页面；replace 可避免返回到空的中间路由。
    window.location.replace(`/api/iam/v1/saml/${encodeURIComponent(samlDomain)}/SSO`);
  }, [samlDomain, shouldAutoRedirect]);

  // 私有化部署配置了租户 domain 时，不展示中间登录页，直接进入企业 IdP。
  if (shouldAutoRedirect) {
    return null;
  }

  const handleSubmit = () => {
    const value = domain.trim();
    if (!value) {
      setError('请输入 domain id 或 domain alias');
      return;
    }
    setError('');
    window.location.href = `/api/iam/v1/saml/${encodeURIComponent(value)}/SSO`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white p-8">
      <div className="w-full max-w-md rounded-xl border bg-card p-6 shadow-sm">
        <h2 className="text-2xl font-bold text-gray-900">SSO 登录</h2>
        <p className="mt-2 text-sm text-muted-foreground">请输入您的 domain id 或 domain alias</p>

        <div className="mt-6 space-y-2">
          <Label htmlFor="sso-domain">Domain</Label>
          <Input
            id="sso-domain"
            type="text"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="例如：605092699300695623 或 acme"
            className="h-11"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
          {error && <p className="text-sm text-destructive">{error}</p>}
        </div>

        <div className="mt-6 flex gap-2">
          <Button type="button" className="flex-1 h-11" onClick={handleSubmit}>
            继续 SSO 登录
          </Button>
          <Button
            type="button"
            variant="outline"
            className="h-11"
            onClick={() => navigate('/login/account')}
          >
            返回
          </Button>
        </div>
      </div>
    </div>
  );
}
